import { PAYMENT_MULTI_STEPS } from '../../utils/steps';
import { StepPerformanceWrapper } from '../atoms/step-performance-wrapper';
import { CareCreditCollectNavigationSwitch } from './care-credit-collect/care-credit-collect-navigation-switch';

export const CareCreditCollect = () => {
  return (
    <StepPerformanceWrapper step={PAYMENT_MULTI_STEPS.careCreditCollect}>
      <CareCreditCollectNavigationSwitch />
    </StepPerformanceWrapper>
  );
};
